import { generateAbsenceUrlBaseV2 } from "utils/utils";
import type { ApiCallerT } from "shared/infrastructure/api/types";
import type {
  BalancesApiT,
  GetAllBalancesResponseT,
} from "../types/balances.types";

export const createBalancesApi = (apiCaller: ApiCallerT): BalancesApiT => ({
  getAll: async ({
    typeId,
    colaboraInstanceId,
    page = 1,
    pageSize = 25,
  }: {
    typeId: string;
    colaboraInstanceId: string;
    page?: number;
    pageSize?: number;
  }) => {
    const queryParams = new URLSearchParams({
      expand: "collaborator",
      page: page.toString(),
      pageSize: pageSize.toString(),
      typeId: typeId,
    });

    const url = generateAbsenceUrlBaseV2(`balances?${queryParams.toString()}`);

    const response = await apiCaller<GetAllBalancesResponseT>(
      url,
      "GET",
      {},
      {},
      {
        "X-Instance-Id": colaboraInstanceId,
      },
    );

    return response;
  },
});
